export default "__VITE_ASSET__BzQAeQ95__"